import { useMemo } from "react";
import { RpServiceConfigurationRedirect } from "@idw-types/data/rp-service-configuration";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { resources } from "@constants/hardcoded-strings";

type RedirectToSelectFormGroupProps = BaseSelectFormGroupProps & {
    redirects: Array<RpServiceConfigurationRedirect>
};

export const RedirectToSelectFormGroup = (props: RedirectToSelectFormGroupProps) => {
    const { redirects, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const redirectToOptions = useMemo(() => {
        return redirects.map(redirect => ({ label: redirect.redirectURI, value: redirect.redirectURI }));
    }, [redirects]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-redirect-to-select`}
            label={resources.common.inputs.redirectTo.label}
            ariaLabel={resources.common.inputs.redirectTo.label}
            automationId={`${idPrefix}-redirect-to-select`}
            onChange={onChange}
            options={redirectToOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};